import React from 'react';

import PropTypes from 'prop-types'

import Header from '../components/common/Header';
import Preloader from '../components/common/Preloader';
import Toastify from '../components/common/Toastify';
import Footer from '../components/common/Footer';

function MainLayout({ children }) {
  // const isMobile = window.screen.width < 768;

  return (
    <>
      <Header />
      <div className="content">
        {children}
      </div>
      <Footer />
      <Preloader />
      <Toastify />
    </>
  );
}

MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MainLayout;